import { httpApi } from "./http.api";

export interface Address {
    tuid: number;
    addressstring: string;
    streetnumber: string;
    streetname: string;
    streettype: string;
    streetdirection: string;
    suburb: string;
    city: string;
    postcode: string;
}

export interface Plan {
    plan_id: string;
    name: string;
    type: string;
    sub_title: string | null;
    description: string | null;
    upload: number;
    download: number;
    option_1: string | null;
    option_2: string | null;
    option_3: string | null;
    data_capped: boolean;
    data_cap: number | null;
    cap_cost: number | null;
    data_unlimited: boolean;
    unlimited_cost: number | null;
    allow_byo: boolean;
    fine_print: string | null;
    routers: Router[];
}

export interface Router {
    router_id: string;
    name: string;
    type: string;
    model_no: string;
    description: string | null;
    cost_device: number;
    cost_shipping: number;
    cost_type: string | 'one-off' | 'monthly';
    cost_term: number;
    option_1: string | null;
    option_2: string | null;
    option_3: string | null;
    option_4: string | null;
    option_5: string | null;
    fine_print: string | null;
}

interface AddressResponse {
    success: boolean;
    addresses: Address[];
}

interface PlansResponse {
    success: boolean;
    plans: Plan[];
}

export const searchAddress = async (query: string): Promise<AddressResponse> => {
    const params = { query: query };
    return await httpApi.get<AddressResponse>(`/address/search`, { params }).then(({ data }) => data);
};

export const getPlans = async (tui: number): Promise<PlansResponse> => {
    return await httpApi.get<PlansResponse>(`/address/plans/${tui}`).then(({ data }) => data);
};
